/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Canextendwrapuptime3Inputs */

const en_entity_canextendwrapuptime3 = /** @type {(inputs: Entity_Canextendwrapuptime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can Extend Wrap-Up Time`)
};

const de_entity_canextendwrapuptime3 = /** @type {(inputs: Entity_Canextendwrapuptime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann Nachbearbeitungszeit verlängern`)
};

/**
* | output |
* | --- |
* | "Can Extend Wrap-Up Time" |
*
* @param {Entity_Canextendwrapuptime3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_canextendwrapuptime3 = /** @type {((inputs?: Entity_Canextendwrapuptime3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Canextendwrapuptime3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_canextendwrapuptime3(inputs)
	return de_entity_canextendwrapuptime3(inputs)
});
export { entity_canextendwrapuptime3 as "entity_canExtendWrapupTime" }